export { default as BookingMemberBooking } from "./MemberBooking";
/** @deprecated Use BookingMemberBooking instead. */
export { default as BookingUserAppointment } from "./MemberBooking";
export { default as BookingScheduleBooking } from "./ScheduleBooking";
export { LocationStep } from "./LocationStep";
export type {
  ScheduleSummary,
  LocationSummary,
  ScheduleStepProps,
  LocationStepProps,
} from "./LocationStep";
export { MemberPanelShell } from "./MemberPanelShell";
export {
  MemberTagBadges,
} from "./MemberTags";
export type { MemberTagView } from "./MemberTags";
export type { MemberPanelShellProps } from "./MemberPanelShell";
export {
  bookingColumnStyle,
  bookingStackGapStyle,
  bookingSectionTitleStyle,
  bookingPageTitleStyle,
  bookingSmallStyle,
  bookingBodyStyle,
  bookingCardStyle,
  selectedLocationSummaryStyle,
  selectedLocationCopyStyle,
  locationChangeButtonStyle,
  memberPanelStyle,
  memberPanelDimmedStyle,
  memberHeaderStyle,
  avatarStyle,
  avatarPlaceholderStyle,
  memberInfoStyle,
  memberNameStyle,
  memberMetaStyle,
  slotsContainerStyle,
  appointmentHeaderStyle,
  appointmentHeaderTitleStyle,
  timeButtonStyle,
  bookingPrimaryActionStyle,
  memberInfoPanelStyle,
  infoPhotosStyle,
  infoPhotoStyle,
  infoBtnStyle,
  consultationRequestBtnStyle,
  consultationRequestBtnHoverCss,
  dateInputContainerStyle,
  dateInputButtonStyle,
  dateInputLabelStyle,
} from "./bookingStyles";

// ── Theme system ────────────────────────────────────────────────────────
export { BookingThemeRoot } from "./BookingThemeRoot";
export type { BookingThemeRootProps } from "./BookingThemeRoot";
export {
  bookingLightTheme,
  bookingDarkTheme,
  resolveBookingTheme,
  buildBookingCssVars,
} from "./bookingTheme";
export type { BookingTheme, BookingThemeMode } from "./bookingTheme";

export { default as BookingDateSelector } from "./components/DateSelector";
export { useBookingDate } from "./components/DateSelector/useBookingDate";
export { bookingTimeZoneFor } from "./bookingTimeZone";
export { default as BookingTimeButton } from "./components/TimeButton";
export { default as BookingOpeningLoading } from "./components/OpeningLoading";
export { default as BookingSelectService } from "./components/SelectService";
export type {
  BookingAppointmentForm,
  BookingOpeningsClient,
  BookingUser,
  BookingUserAppointmentProps,
  BookingScheduleBookingProps,
  SelectedService,
} from "./types";

// ── Consultation / Service Request ─────────────────────────────────────
export { default as ConsultationDrawer } from "./ConsultationDrawer";
export { default as ServiceConsultation } from "./ServiceConsultation";
export { default as ServiceRequestForm } from "./ServiceRequestForm";
export type {
  ConsultationService,
  ServiceRequestPayload,
} from "./ServiceRequestForm";
export type { MediaUploadFn } from "./ServiceRequestForm/Uploader";

// ── Re-exports from @openings/booking-core ─────────────────────────────
// Shared logic & types for all booking surfaces (no React dependency).
export {
  filterBusinessServices,
  getServiceDuration,
  getServicePrice,
  calculateCombinedDuration,
  calculateCombinedPrice,
  resolveServiceOption,
  buildOpeningsServicePayload,
  findMemberService,
  hasConsultationRequired,
  formatTime12,
  formatPrice,
  formatDuration,
  formatMinutes,
  formatDateShort,
  formatDateLong,
  toDateString,
} from "@openings/booking-core";

export type {
  ServiceOptionItem,
  ServiceItem,
  SelectedServiceItem,
  ScheduleLocationItem,
  LocationItem as BookingCoreLocationItem,
  ScheduleInfo,
  MemberServiceInfo,
  MemberOpeningsItem,
  OpeningsServicePayload,
  BookingSelection,
  OnSlotSelected,
} from "@openings/booking-core";
